module.exports = { "default": require("core-js/library/fn/object/set-prototype-of"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ../~/react-event-listener/~/babel-runtime/core-js/object/set-prototype-of.js
 ** module id = 804
 ** module chunks = 3
 **/